import { StoreState } from "~/redux/reducers";

export const selectScanAndApplyLabelModalActiveStep = (state: StoreState) =>
  state.scanAndApplyLabel.scanAndApplyModalActiveStep;

export const selectPickingScannedBarcode = (state: StoreState) =>
  state.pickingScannedBarcode.scannedBarcode;
